/** API origin the screenshots are served from (`/whats-new/...` on the API's static files). */
const API_BASE_URL: string = import.meta.env.VITE_MESTERPLAN_API_URL ?? '';

/** Site-relative screenshot paths are served by the API host; absolute URLs pass through. */
export function resolveImageUrl(url: string, baseUrl: string = API_BASE_URL): string {
  if (/^https?:\/\//i.test(url)) return url;
  const base = baseUrl.replace(/\/+$/, '');
  return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`;
}
